import type { Router } from 'vue-router';
import { getHostRouter } from '@Src/mfe.config';

export const syncRouterToHost = async (router: Router) => {
    const hostRouter = getHostRouter();
    const hostPath = hostRouter?.currentRoute?.value?.fullPath;

    if (hostPath && hostPath !== router.currentRoute.value.fullPath) {
        console.log('[Dashboard MFE] Syncing router to host path:', hostPath);
        await router.replace(hostPath);
    }
};
